import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Niue: Country = {
    identifier: "Niue",
    name: "Niue",
    countryCode: "NU",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇳🇺",
    svgPath: "m 1008.6787,517.1444 -0.281,0.162 -0.125,-0.192 0.111,-0.244 0.132,-0.063 0.078,-0.008 0.114,0.226 z",
}
